import { z } from 'zod';
import { DiagramAreaLinkType } from '~/apollo/generated/v4/graphql';
import {
  geologyWikiPageRoute,
  lithostratFormationRoute,
  lithostratGroupRoute,
  lithostratMemberRoute,
} from '~/paths';
import { assertExhaustive } from '~/utils/common';
import { ppNumberOrNull } from '~/utils/zod';

export const diagramAreaSchema = z.object({
  label: z.string().min(1),
  linkTargetType: z.nativeEnum(DiagramAreaLinkType),
  linkTargetId: z.preprocess(ppNumberOrNull, z.number().int()),
  path: z
    .array(
      z.object({
        x: z.number(),
        y: z.number(),
      }),
    )
    .min(3),
});

export type DiagramAreaFormValues = {
  label: string;
  linkTargetType: DiagramAreaLinkType;
  linkTargetId: string;
  path: Array<{ x: number; y: number }>;
};

export function initialDiagramArea(): DiagramAreaFormValues {
  return {
    label: '',
    linkTargetType: DiagramAreaLinkType.GeologyWiki,
    linkTargetId: '',
    path: [],
  };
}

export function linkTarget(targetType: DiagramAreaLinkType, targetId: number) {
  switch (targetType) {
    case DiagramAreaLinkType.GeologyWiki:
      return geologyWikiPageRoute(targetId);
    case DiagramAreaLinkType.Formation:
      return lithostratFormationRoute(targetId);
    case DiagramAreaLinkType.Group:
      return lithostratGroupRoute(targetId);
    case DiagramAreaLinkType.Member:
      return lithostratMemberRoute(targetId);
    default:
      throw assertExhaustive(targetType);
  }
}
